import { FC } from "react";
import { Box } from "@material-ui/core";
import { useTypeSelectors } from "hooks/useTypeSelectors";
import { useStyles } from "./styles";
import Loader from "router/components/Loader";
import DaHead from "./DaContent/DaHead";
import DaStatussContainers from "./DaContent/DaStatusContainers";
import DaGraphSection from "./DaContent/DaGraphSection";
import { useDispatch } from "react-redux";
import { daUpdateSettings, resetDaSelectedList } from "actions/daAndFleetActions";
import PaginationSwitch from "componentsNew/elements/PaginationSwitch";

const DaAndFleetsPage: FC = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const {
    loadingData,
    driverData: { driverListCount, driverListFilters },
  } = useTypeSelectors((state) => state.daAndFleets);

  const handleChangePagination = (event: unknown, value: number) => {
    dispatch(daUpdateSettings({ pageNumber: Number(value) }));
    dispatch(resetDaSelectedList());
  };

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(daUpdateSettings({ rowsPerPage: Number(event.target.value) }));
    dispatch(resetDaSelectedList());
  };

  return (
    <Box className={classes.root} id="Table">
      <Loader isLoading={loadingData} />
      <DaHead />
      <Box className={classes.contentBox}>
        <DaGraphSection />
        <DaStatussContainers />
        <Box className={classes.tableFooter}>
          <PaginationSwitch
            page={driverListFilters?.pageNumber}
            rowsPerPage={driverListFilters?.rowsPerPage}
            totalPages={driverListCount}
            handleChangeRowsPerPage={handleChangeRowsPerPage}
            handleChangePage={handleChangePagination}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default DaAndFleetsPage;
